//display date in this format : Jeudi 25 Janvier 2024
module.exports.dateLong = (date, gmt = "UTC") => {
  return date.toLocaleDateString("fr-FR", {
    timeZone: gmt,
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

//display date in this format : 25 Janvier
module.exports.dateShortText = (date, gmt = "UTC") => {
  const options = {
    timeZone: gmt,
    day: "2-digit",
    month: "long",
  };

  const formattedDate = new Intl.DateTimeFormat("fr-FR", options).format(date);
  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
};

//display date in this format : 25 Janv.
module.exports.dateShortText2 = (date, gmt = "UTC") => {
  const options = {
    timeZone: gmt,
    day: "2-digit",
    month: "short",
  };

  const formattedDate = new Intl.DateTimeFormat("fr-FR", options).format(date);
  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
};

/** Jour calendrier local ; `hideYear` pour n’afficher que jour + mois court (ex. plage sur une même année). */
module.exports.dateShortText2Local = (date, { hideYear = false } = {}) => {
  if (date == null) return "";
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  const options = hideYear
    ? { day: "2-digit", month: "short" }
    : { day: "2-digit", month: "short", year: "numeric" };
  const formattedDate = new Intl.DateTimeFormat("fr-FR", options).format(d);
  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
};

//display date in this format : 2024-02-29 09:00
module.exports.dateShortHours = (date, separator = "-") => {
  const formattedDate = new Date(date);

  const year = formattedDate.getFullYear();
  const month = (formattedDate.getMonth() + 1).toString().padStart(2, "0");
  const day = formattedDate.getDate().toString().padStart(2, "0");
  const hours = formattedDate.getHours().toString().padStart(2, "0");
  const minutes = formattedDate.getMinutes().toString().padStart(2, "0");

  return `${year}${separator}${month}${separator}${day} ${hours}:${minutes}`;
};

//display date in this format : JJ-MM
module.exports.dateShort = (date) => {
  const formattedDate = new Date(date);

  const day = formattedDate.getDate().toString().padStart(2, "0");
  const month = (formattedDate.getMonth() + 1).toString().padStart(2, "0");

  return `${day}-${month}`;
};

//display in this format : JJ-MM HH:MM
module.exports.dateShortHoursWithoutYear = (date, separator = "-") => {
  const formattedDate = new Date(date);

  const day = formattedDate.getDate().toString().padStart(2, "0");
  const month = (formattedDate.getMonth() + 1).toString().padStart(2, "0");
  const hours = formattedDate.getHours().toString().padStart(2, "0");
  const minutes = formattedDate.getMinutes().toString().padStart(2, "0");

  return `${day}${separator}${month} ${hours}:${minutes}`;
};

//check date validity
module.exports.dateStringIsValid = (dateString) => {
  let dateStr = dateString;

  //detect if birthDate has this regex /^..-..-....$/ or /^..\/..\/....$/ (xx-xx-xxxx or xx/xx/xxxx)
  if (dateStr.match(/^..-..-....$/) || dateStr.match(/^..\/..\/....$/)) {
    //detect if - or / in date
    if (dateStr.includes("-")) {
      const dateParts = dateStr.split("-");
      dateStr = dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];
    } else {
      const dateParts = dateStr.split("/");
      dateStr = dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];
    }
  }
  const date = new Date(dateStr);
  return date instanceof Date && !isNaN(date);
};

module.exports.formatTimeDifference = (timeDifferenceDate) => {
  const years = timeDifferenceDate.getUTCFullYear() - 1970;
  const months = timeDifferenceDate.getUTCMonth();
  const days = timeDifferenceDate.getUTCDate() - 1;
  const hours = timeDifferenceDate.getUTCHours();
  const minutes = timeDifferenceDate.getUTCMinutes();
  const seconds = timeDifferenceDate.getUTCSeconds();

  if (years > 0) {
    return `${years} an${years > 1 ? "s" : ""}`;
  } else if (months > 0) {
    return `${months} mois`;
  } else if (days > 0) {
    return `${days} jour${days > 1 ? "s" : ""}`;
  } else if (hours > 0) {
    return `${hours} heure${hours > 1 ? "s" : ""}`;
  } else if (minutes > 0) {
    return `${minutes} minute${minutes > 1 ? "s" : ""}`;
  } else {
    return `${seconds} seconde${seconds > 1 ? "s" : ""}`;
  }
};

module.exports.dateToEpoch = (date) => {
  const dateWithoutTime = this.dateWithoutTime(date);
  const userTimezoneOffset = dateWithoutTime.getTimezoneOffset() * 60000;
  return new Date(dateWithoutTime.getTime() - userTimezoneOffset);
};

module.exports.dateWithoutTime = (date) => {
  //if real date
  if (date instanceof Date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  } else {
    //if epoch
    const dateF = new Date(date);
    return new Date(dateF.getFullYear(), dateF.getMonth(), dateF.getDate());
  }
};

//convert date 2024-08-01T00:00:00.000Z to 2024-08-01T00:00:00.000Z + current timezone offset
module.exports.forceDateToUtc0 = (dateString) => {
  const date = new Date(dateString);
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() + userTimezoneOffset);
};

// Calendar date in local timezone as YYYY-MM-DD (no time; preferred payload for APIs).
module.exports.dateToYYYYMMDD = (d) => {
  if (!d) return null;
  const x = new Date(d);
  const y = x.getFullYear();
  const m = String(x.getMonth() + 1).padStart(2, "0");
  const day = String(x.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

/** Selected calendar day in local TZ → Date at 12:00 local (pickers; avoids midnight/DST edge cases). */
module.exports.toLocalCalendarNoon = (d) => {
  if (d == null) return null;
  const x = new Date(d);
  if (Number.isNaN(x.getTime())) return null;
  return new Date(x.getFullYear(), x.getMonth(), x.getDate(), 12, 0, 0, 0);
};

/**
 * Plain YYYY-MM-DD → local calendar date at noon (stable for pickers / URLs).
 * Legacy full ISO strings → normalized to the same local calendar day at noon.
 */
module.exports.parseCalendarDateParam = (str) => {
  if (str == null || str === "") return null;
  const trimmed = String(str).trim();
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmed);
  if (match) {
    const y = Number(match[1]);
    const mo = Number(match[2]) - 1;
    const d = Number(match[3]);
    const dt = new Date(y, mo, d, 12, 0, 0, 0);
    if (dt.getFullYear() !== y || dt.getMonth() !== mo || dt.getDate() !== d) {
      return null;
    }
    return dt;
  }
  const t = new Date(trimmed);
  if (Number.isNaN(t.getTime())) return null;
  return module.exports.toLocalCalendarNoon(t);
};

module.exports.todayAtLocalCalendarNoon = () =>
  module.exports.toLocalCalendarNoon(new Date());

/** Same local calendar day (YYYY-MM-DD local). */
module.exports.isSameLocalCalendarDay = (a, b) => {
  if (!a || !b) return false;
  return module.exports.dateToYYYYMMDD(a) === module.exports.dateToYYYYMMDD(b);
};

/** Both bounds are today's local calendar day. */
module.exports.isLocalCalendarTodayRange = (start, end) => {
  if (!start || !end) return false;
  const today = module.exports.dateToYYYYMMDD(new Date());
  return (
    module.exports.dateToYYYYMMDD(start) === today &&
    module.exports.dateToYYYYMMDD(end) === today
  );
};

// Display period label: "Lun 13 Jan. 2026 > Dim 20 Jan. 2026" or dateLong if same day
module.exports.datePeriodLabel = (startDate, endDate, gmt = "UTC") => {
  if (!startDate || !endDate) return "";
  const start = new Date(startDate);
  const end = new Date(endDate);

  const isSameDay =
    start.toLocaleDateString("fr-FR", { timeZone: gmt }) ===
    end.toLocaleDateString("fr-FR", { timeZone: gmt });

  if (isSameDay) return module.exports.dateLong(start, gmt);

  const fmt = (date) => {
    const formatted = new Intl.DateTimeFormat("fr-FR", {
      timeZone: gmt,
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
    }).format(date);
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  };

  return `${fmt(start)} > ${fmt(end)}`;
};

// Short period label for compact display: "13 Janv. > 20 Janv." or "13 Janv." if same day
module.exports.datePeriodShort = (startDate, endDate, gmt = "UTC") => {
  if (!startDate) return "";
  const start = new Date(startDate);
  const end = endDate ? new Date(endDate) : null;

  const fmt = (date) => {
    const formatted = new Intl.DateTimeFormat("fr-FR", {
      timeZone: gmt,
      day: "numeric",
      month: "short",
    }).format(date);
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  };

  if (!end) return fmt(start);

  const isSameDay =
    start.toLocaleDateString("fr-FR", { timeZone: gmt }) ===
    end.toLocaleDateString("fr-FR", { timeZone: gmt });

  if (isSameDay) return fmt(start);

  return `${fmt(start)} > ${fmt(end)}`;
};

// Calculate date range around a center date (J-daysBefore to J+daysAfter)
module.exports.calculateDateRange = (centerDate, daysBefore = 2, daysAfter = 2) => {
  if (!centerDate) return { min: null, max: null };
  const center = new Date(centerDate);
  center.setHours(0, 0, 0, 0);
  const dayMs = 24 * 60 * 60 * 1000;
  const min = new Date(center.getTime() - daysBefore * dayMs);
  const max = new Date(center.getTime() + daysAfter * dayMs);
  return { min, max };
};
